import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import Dict from "../../../helper/dict";
import {PencilIcon} from "@heroicons/react/24/solid";
import persianNumberFormat from "../../../helper/PersianNumberFormat";


const TABLE_HEAD = ["#", "عنوان", "وضعیت", "عملیات"];

export function RoleGrid({roles, setModalOpen, setSelectedRow}) {

  return (
    <table className="mt-4 w-full min-w-max table-auto text-left">
      <thead>
      <tr>
        {TABLE_HEAD.map((head, index) => (
          <th key={head}
              className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
            <Typography variant="small" color="blue-gray"
                        className="flex items-center justify-between gap-2 font-normal leading-none opacity-70 flex justify-center">
              {head}{" "}
              {index !== TABLE_HEAD.length - 1 && (
                <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky "/>
              )}
            </Typography>
          </th>
        ))}
      </tr>
      </thead>
      <tbody>
      {roles.map(
        ({id, title, status}, index) => {
          const isLast = index === roles.length - 1;
          const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

          return (
            <tr key={id}>
              <td className={classes}>
                <div className="flex justify-center">
                  <Typography color="blue-gray">
                    {persianNumberFormat(index + 1, true)}
                  </Typography>
                </div>
              </td>
              <td className={classes}>
                <div className="flex justify-center">
                  <Typography color="blue-gray">
                    {title}
                  </Typography>
                </div>
              </td>
              <td className={classes}>
                <div className="flex justify-center">
                  <Chip variant="ghost"
                        value={Dict(status)}
                        color={status === "enable" ? "green" : status === "disable" ? "amber" : "red"}
                  />
                </div>
              </td>
              <td className={`${classes} flex justify-center`}>
                <Tooltip content="ویرایش">
                  <IconButton variant="text" className="text-align=right" onClick={() => {
                    setSelectedRow(roles[index]);
                    setModalOpen(true);
                  }}>
                    <PencilIcon className="h-4 w-4"/>
                  </IconButton>
                </Tooltip>
              </td>
            </tr>
          );
        },
      )}
      </tbody>
    </table>
  );
}